/**
 * Shared, typed "source" values for Mixpanel events.
 *
 * Keep these stable (they become part of event payloads).
 */
export const MIXPANEL_SOURCE = {
  CORPORATIONS_TAB: 'corporations_tab',
  ENTITY_MANAGEMENT: 'entity_management',
  CALENDAR: 'calendar',
  CALENDAR_ONBOARDING: 'calendar_onboarding',
  COMPLIANCE_UPSELL: 'compliance_upsell',
  MAILROOM: 'mailroom',
} as const;

export type MixpanelSource =
  (typeof MIXPANEL_SOURCE)[keyof typeof MIXPANEL_SOURCE];
